import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

interface PageTransitionProps {
  children: React.ReactNode;
}

const PageTransition: React.FC<PageTransitionProps> = ({ children }) => {
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [displayChildren, setDisplayChildren] = useState(children);
  const location = useLocation();

  useEffect(() => {
    // Starte die Transition beim Routenwechsel
    setIsTransitioning(true);
    
    // Kurze Verzögerung für den Fade-Out-Effekt
    const timer = setTimeout(() => {
      setDisplayChildren(children);
      setIsTransitioning(false);
    }, 150); // 150ms für unmerklichen aber smoothen Übergang

    return () => clearTimeout(timer);
  }, [location.pathname, children]);

  return (
    <div 
      className={`page-transition-wrapper ${isTransitioning ? 'transitioning' : ''}`}
      style={{
        transition: 'opacity 150ms ease-in-out, transform 80ms ease-out',
        opacity: isTransitioning ? 0.85 : 1,
        transform: isTransitioning ? 'translateY(5px)' : 'translateY(0)',
        width: '100%',
        height: '100%'
      }}
    >
      {displayChildren}
    </div>
  );
};

export default PageTransition; 